import { toConsumableArray as _toConsumableArray } from '../../_virtual/_rollupPluginBabelHelpers.js';

/**
 * Convert array from flat to nested by using size.
 * ex) [1, 2, 3, 4, 5], 3 -> [[1, 2, 3], [4, 5]]
 * @param {T[]} array
 * @param {number} size
 * @return {T[]}
 */
function group(array, size) {
  return array.reduce(function (acc, cur) {
    var _acc$length, _acc, _acc2;
    return ((_acc$length = (_acc = acc[acc.length - 1]) === null || _acc === void 0 ? void 0 : _acc.length) !== null && _acc$length !== void 0 ? _acc$length : 0) < size ? [].concat(_toConsumableArray(acc.slice(0, -1)), [[].concat(_toConsumableArray((_acc2 = acc[acc.length - 1]) !== null && _acc2 !== void 0 ? _acc2 : []), [cur])]) : [].concat(_toConsumableArray(acc), [[cur]]);
  }, []);
}

/**
 * Pad on specified sized array end with 'undefined'
 * ex) [1], 3 -> [1, undefined, undefined]
 *
 * @param {T[]} array
 * @param {number} size
 * @param {T} padding
 * @return {(T | undefined)[]}
 */
function pad(array, size, padding) {
  return array.concat(Array(size).fill(padding)).slice(0, size);
}

export { group, pad };
//# sourceMappingURL=utils.js.map
